// extracted by mini-css-extract-plugin
export default {"gtmInput":"GtmInput_gtmInput__Kc3Ys"};